<template>
  <div class="header">
    <div class="left">
      <img class="logo"
        alt=""
        src="../../../assets/images/soso_logo.png" />
      <span class="name">后台管理系统</span>
    </div>
    <div class="right">
      <svg-icon icon-class="head_img"
        class="head_img" />
      <span class="username">{{ username }}</span>
      <div class="login-out"
        @click="logout">
        <svg-icon icon-class="login_out"
          class="icon" />退出
      </div>

      <div class="login-out"
        @click="changePassword">
        <svg-icon icon-class="password"
          class="icon" />修改密码
      </div>
    </div>

    <gydialog title="修改密码"
      :visible.sync="showChangePass"
      width="540px">
      <div style="padding:20px 30px;">
        <span style="color:#f4222d;margin-right:6px;">*</span>
        <span style="margin-right:12px;">登陆密码:</span>
        <el-input size="mini"
          v-model="password"
          style="width:270px"
          placeholder="请输入密码">
        </el-input>
      </div>
      <div style="text-align:center;margin:20px;">
        <el-button size="mini"
          @click="cancelChange">取消</el-button>
        <el-button size="mini"
          type="primary"
          @click="certainChange">确定</el-button>
      </div>
    </gydialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { passwordupdate } from '@/api/account'
export default {
  computed: {
    ...mapGetters(['username'])
  },
  data () {
    return {
      showChangePass: false,
      password: ''
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('quitLogin').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    changePassword () {
      this.showChangePass = true
    },
    async certainChange () {
      if (this.password.length < 6) {
        this.$message.error('密码不能少于6位')
        return
      }

      let res = await passwordupdate({ password: this.password })
      console.log(res)
      this.logout()
    },
    cancelChange () {
      this.password = ''
      this.showChangePass = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'src/styles/element-variables.scss';
.header {
	background-color: #fff;
	height: 72px;
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	min-width: 1200px;
	box-shadow: 1px 2px 10px 0px rgba(51, 51, 51, 0.1);
	display: flex;
	align-items: center;
	justify-content: space-between;
	.left {
		padding: 0 20px;
		display: flex;
		align-items: center;
		.logo {
			width: 42px;
			height: 42px;
			border-radius: 21px;
			background-color: $--color-primary;
		}
		.name {
			margin-left: 20px;
			padding-left: 24px;
			border-left: 1px solid #d4d4d4;
			color: #333;
		}
	}
	.right {
		margin-right: 12px;
		display: flex;
		align-items: center;
		.head_img {
			font-size: 33px;
			color: #333;
			margin-right: 6px;
		}
		.username {
			font-size: 14px;
			text-decoration: underline;
			padding-right: 20px;
		}

		.login-out {
			padding: 0 20px;
			font-size: 14px;
			cursor: pointer;
			border-left: 1px solid #d4d4d4;
			.icon {
				margin-right: 6px;
			}
		}
	}
}
</style>
